import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import HelpOutlineOutlinedIcon from "@material-ui/icons/HelpOutlineOutlined";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { ElectricitySummaryIcon, LPGSummaryIcon } from "./Icons";

const sideIcons = {
  marginRight: "1rem",
};
const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#00A9E2",
    color: "#fff",
    maxWidth: 200,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #00A9E2",
  },
  arrow: {
    color: "#00A9E2",
  },
}))(Tooltip);

const tooltipsIcon = {
  paddingLeft: "0px",
  display: "flex",
  alignItems: "center",
  gap: "1px",
};
const useStyles = makeStyles(() => ({
  customWidth: {
    maxWidth: 220,
  },
}));
export default function SidebarServicesSummary(props) {
  const classes = useStyles();
  const [discount, setDiscount] = React.useState(0);
  const [userClassDesc, setUserClassDesc] = React.useState("");
  const [isGasPage, setIsGasPage] = React.useState(false);
  const [isLPGPage, setIsLPGPage] = React.useState(false);

  const handleEdit = (editStep) => {
    props.editFunction(editStep);
  };

  const formatRates = (rates) => {
    if (props.noGst) {
      rates = rates * 1.15;
    }
    return parseFloat(rates).toFixed(3) + " ¢";
  };
  const formatDollarRates = (rates) => {
    if (props.noGst) {
      rates = rates * 1.15;
    }
    return "$" + parseFloat(rates).toFixed(2);
  };
  const formatKey = (key) => {
    let k = key.replace(/([A-Z])/g, " $1").trim();
    return k;
  };
  React.useEffect(() => {
    let gasRatesResult = props.values.gasRatesResult;
    if (props.step === 6) {
      setIsGasPage(true);
    } else {
      setIsGasPage(false);
    }
    if (props.step === 7) {
      setIsLPGPage(true);
    } else {
      setIsLPGPage(false);
    }

    if (
      gasRatesResult instanceof Object &&
      gasRatesResult.MyGasQuote.GasQuote instanceof Array
    ) {
      //  setRatesStatus(false)
      //set negative to absolute and set as discount variable
      setDiscount(30);
    }
    if (props.values.gasUserClass instanceof Array) {
      props.values.gasUserClass.map(function (item) {
        if (item.UserClassCode === props.values.gasUserCode) {
          setUserClassDesc(item.UserClassDescription);
        }
      });
    }
  }, [
    props.values.gasRatesResult,
    props.values.gasUserClass,
    props.values.gasUserCode,
    props.step,
  ]);

  const ElectricityRates = () => {
    const electricityHtml = props.values.ratesResult.MyQuote.QuoteBase.map(function (
      item,
      i
    ) {
      return (
        <React.Fragment>
          {item.ContentDesc === "Fixed Daily Charges" ? (
            <React.Fragment>
              <tr>
                <td style={tooltipsIcon}>
                  <strong>Fixed</strong>&nbsp;
                  <HtmlTooltip
                    arrow
                    classes={{ tooltip: classes.customWidth }}
                    placement="top"
                    disableFocusListener
                    interactive={true}
                    enterTouchDelay={-100}
                    leaveTouchDelay={5000}
                    title={
                      <div
                        dangerouslySetInnerHTML={{
                          __html: props.values.fixedTooltips,
                        }}
                      ></div>
                    }
                  >
                    <HelpOutlineOutlinedIcon
                      fontSize="medium"
                      style={{ cursor: "pointer" }}
                    />
                  </HtmlTooltip>
                </td>
              </tr>
              <tr>
                <td style={{ paddingLeft: "0" }}>
                  {item.ContentDesc}
                </td>
                <td align="right">
                  {formatRates(item.Rate) + "/Day"}
                </td>
              </tr>
              <tr>
                <td style={tooltipsIcon}>
                  <strong>Usage</strong>&nbsp;
                  <HtmlTooltip
                    classes={{ tooltip: classes.customWidth }}
                    placement="top"
                    arrow={true}
                    disableFocusListener
                    interactive={true}
                    enterTouchDelay={-100}
                    leaveTouchDelay={5000}
                    title={
                      <div
                        dangerouslySetInnerHTML={{
                          __html: props.values.usageTooltips,
                        }}
                      ></div>
                    }
                  >
                    <HelpOutlineOutlinedIcon
                      style={{ cursor: "pointer" }}
                      fontSize="medium"
                    />
                  </HtmlTooltip>
                </td>
              </tr>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <tr>
                <td style={{ paddingLeft: "0" }}>
                  {item.ContentDesc}
                </td>
                <td align="right">
                  {!!item.Rate && (
                    <div>{formatRates(item.Rate)}/kWh</div>
                  )}
                  {!!item.SummerRate && (
                    <div style={{ marginBottom: "8px" }}>
                      <strong>Summer</strong>
                      <br />
                      {formatRates(item.SummerRate)}/kWh
                    </div>
                  )}
                  {!!item.WinterRate && (
                    <div>
                      <strong>Winter</strong>
                      <br />
                      {formatRates(item.WinterRate)}/kWh
                    </div>
                  )}
                </td>
              </tr>
            </React.Fragment>
          )}
        </React.Fragment>
      );
    });

    return electricityHtml;
  }

  const PowerLunchRates = () => {
    const quoteItems = props.values.lunchRatesResult.MyQuote.QuoteBase;
  
    // Get first non-fixed ContentCode group (skip Fixed Daily Charges)
    const firstGroupCode = quoteItems.find(
      item => item.ContentDesc !== 'Fixed Daily Charges'
    )?.ContentCode;
  
    // Filter to only include:
    // - Fixed Daily Charges (always)
    // - The first group based on ContentCode
    const filteredItems = quoteItems.filter(item =>
      item.ContentDesc === 'Fixed Daily Charges' ||
      item.ContentCode === firstGroupCode
    );
  
    const electricityHtml = filteredItems.map((item, i) => {
      return (
        <React.Fragment key={i}>
          {item.ContentDesc === "Fixed Daily Charges" ? (
            <React.Fragment>
              <tr>
                <td style={tooltipsIcon}>
                  <strong>Fixed</strong>&nbsp;
                  <HtmlTooltip
                    arrow
                    classes={{ tooltip: classes.customWidth }}
                    placement="top"
                    disableFocusListener
                    interactive={true}
                    enterTouchDelay={-100}
                    leaveTouchDelay={5000}
                    title={
                      <div
                        dangerouslySetInnerHTML={{
                          __html: props.values.fixedTooltips,
                        }}
                      ></div>
                    }
                  >
                    <HelpOutlineOutlinedIcon
                      fontSize="medium"
                      style={{ cursor: "pointer" }}
                    />
                  </HtmlTooltip>
                </td>
              </tr>
              <tr>
                <td style={{ paddingLeft: "0" }}>{item.ChargeDesc}</td>
                <td align="right">{formatRates(item.Rate) + "/Day"}</td>
              </tr>
              <tr>
                <td style={tooltipsIcon}>
                  <strong>Usage</strong>&nbsp;
                  <HtmlTooltip
                    classes={{ tooltip: classes.customWidth }}
                    placement="top"
                    arrow={true}
                    disableFocusListener
                    interactive={true}
                    enterTouchDelay={-100}
                    leaveTouchDelay={5000}
                    title={
                      <div
                        dangerouslySetInnerHTML={{
                          __html: props.values.usageTooltips,
                        }}
                      ></div>
                    }
                  >
                    <HelpOutlineOutlinedIcon
                      style={{ cursor: "pointer" }}
                      fontSize="medium"
                    />
                  </HtmlTooltip>
                </td>
              </tr>
            </React.Fragment>
          ) : (
            <tr>
              <td style={{ paddingLeft: "0" }}>{item.ChargeDesc}</td>
              <td align="right">
                {Number(item.Rate) === 0 ? (
                  <div>Free</div>
                ) : (
                  !!item.Rate && <div>{formatRates(item.Rate)}/kWh</div>
                )}
              </td>
            </tr>
          )}
        </React.Fragment>
      );
    });
  
    return electricityHtml;
  };

  const PowerShiftRates = () => {

    if (props.values.powerRatesResult.MyQuote) {

     let ratesResult = props.values.powerRatesResult.MyQuote.QuoteBase.map(function(item, i) {
       let rateContent = null;
       let summerRate = null;
       let winterRate = null;

       if (item.ContentDesc === 'Fixed Daily Charges') {
           rateContent = formatRates(item.Rate) + '/Day';

           const contentDesc = (item.ContentDesc !== 'Fixed Daily Charges' && item.ChargeDesc) && (<span> - {item.ChargeDesc}</span>);
           return (
              <tr>
                <td style={{ paddingLeft: "0" }}>
                  <strong>{item.ContentDesc}{contentDesc}</strong>
                </td>
                <td align="right">
                {!!rateContent && rateContent}
                </td>
              </tr>
           );
       } 
     });

     let weekdaysFirstRate = '';
     let weekdaysSecondRate = '';
     let weekdaysThirdtRate = '';
     let weekendFirstRate = '';
     let weekendSecondRate = '';
     let weekendThirdtRate = '';
     props.values.powerRatesResult.MyQuote.QuoteBase.forEach((item, i) => {
               
         if (item.ChargeDesc === 'Weekdays Peak: 7am-11am & 5pm-9pm') {
             weekdaysFirstRate = formatRates(item.Rate) + '/kWh';
         }
               
         if (item.ChargeDesc === 'Weekdays Off-Peak: 11am-5pm & 9pm-11pm') {
            weekdaysSecondRate = formatRates(item.Rate) + '/kWh';
         }
               
         if (item.ChargeDesc === 'Weekdays Night: 11pm-7am') {
            weekdaysThirdtRate = formatRates(item.Rate) + '/kWh';
         }
               
         if (item.ChargeDesc === 'Weekends Peak: 7am-11am & 5pm-9pm') {
            weekendFirstRate = formatRates(item.Rate) + '/kWh';
         }
               
         if (item.ChargeDesc === "Weekends Off-Peak: 11am-5pm & 9pm-11pm") {
            weekendSecondRate = formatRates(item.Rate) + '/kWh';
         }
               
         if (item.ChargeDesc === "Weekends Night: 11pm-7am") {
            weekendThirdtRate = formatRates(item.Rate) + '/kWh';
         }
         
     });
     
     const rateList = <>
        <tr>
          <td style={{ paddingLeft: "0" }}>
            <strong>Weekdays</strong>
          </td>
          <td align="right">
            &nbsp;
          </td>
        </tr>
        <tr>
          <td style={{ paddingLeft: "0" }}>
            Peak: 7am-11am & 5pm-9pm
          </td>
          <td align="right">
            {weekdaysFirstRate}
          </td>
        </tr>
        <tr>
          <td style={{ paddingLeft: "0" }}>
            Off-Peak: 11am-5pm & 9pm-11pm
          </td>
          <td align="right">
            {weekdaysSecondRate}
          </td>
        </tr>
        <tr>
          <td style={{ paddingLeft: "0" }}>
            Night: 11pm-7am
          </td>
          <td align="right">
            {weekdaysThirdtRate}
          </td>
        </tr>
        <tr>
          <td style={{ paddingLeft: "0" }}>
            <strong>Weekends</strong>
          </td>
          <td align="right">
            &nbsp;
          </td>
        </tr>
        <tr>
          <td style={{ paddingLeft: "0" }}>
            Peak: 7am-11am & 5pm-9pm
          </td>
          <td align="right">
            {weekendFirstRate}
          </td>
        </tr>
        <tr>
          <td style={{ paddingLeft: "0" }}>
            Off-Peak: 11am-5pm & 9pm-11pm
          </td>
          <td align="right">
            {weekendSecondRate}
          </td>
        </tr>
        <tr>
          <td style={{ paddingLeft: "0" }}>
            Night: 11pm-7am
          </td>
          <td align="right">
            {weekendThirdtRate}
          </td>
        </tr>
    </>;
     
    return (
         <>
             {ratesResult}
             {rateList}
         </>
     );

    }
  }

  const displaySummary = () => {
    if (
      props.values.servicesArray.sort() instanceof Array &&
      props.values.servicesArray.sort().length !== 0
    ) {
      return props.values.servicesArray.sort().map((service) => (
        <div className="service-sidebar-item" key={service}>
          <h5 className="h5 primary service-icon-wrapper">
            {/* if electricity then display e icon */}
            {service === "electricity" ? (
              <React.Fragment>
                <div className="service-icon service-icon-sidebar">
                  <ElectricitySummaryIcon />
                </div>{" "}
                {service.toUpperCase()}{" "}
              </React.Fragment>
            ) : !isLPGPage && service === "lpg" ? (
              <React.Fragment>
                <div className="service-icon service-icon-sidebar">
                  <LPGSummaryIcon />
                </div>{" "}
                {service.toUpperCase()}{" "}
              </React.Fragment>
            ) : (
              !isGasPage &&
              service === "gas" && (
                <React.Fragment>
                  <div className="service-icon service-icon-sidebar">
                    <svg
                      width="53"
                      height="39"
                      viewBox="0 0 81 75"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="40" cy="40" r="40" fill="#035D67" />
                      <g clipPath="url(#clip0_22_1432)">
                        <path d="M29.2615 46.568L29.2615 46.568C28.2632 44.3283 28.3593 42.048 28.7116 40.3134C29.0641 38.5782 29.6763 37.3722 29.731 37.2666C29.7889 37.1549 29.8808 37.0653 29.9917 37.007C30.1024 36.9487 30.2283 36.9236 30.3531 36.9334C30.4778 36.9433 30.5982 36.9879 30.6978 37.0638C30.7954 37.138 30.8692 37.2394 30.9066 37.3566C31.1939 38.1019 31.6749 38.7724 32.3081 39.3105C32.8533 37.1888 34.1107 35.4857 35.268 34.2889C36.4631 33.0529 37.5638 32.3439 37.7003 32.2577C38.9649 31.3257 39.0939 29.9354 38.8816 28.7231C38.7756 28.1179 38.5857 27.5697 38.4201 27.1691C38.3374 26.9692 38.2612 26.8071 38.2052 26.6943C38.1773 26.638 38.1544 26.594 38.1384 26.5638C38.1303 26.5487 38.124 26.5371 38.1197 26.5291C38.1158 26.5221 38.1137 26.5183 38.1132 26.5175L38.1132 26.5174L38.1131 26.5172C38.0425 26.3935 38.0197 26.2492 38.0507 26.1097C38.0817 25.9707 38.1631 25.8496 38.2763 25.7646C38.3891 25.6799 38.5278 25.6351 38.6688 25.6347C38.8098 25.6343 38.9488 25.6783 39.0621 25.7624L39.0624 25.7625C42.8498 28.5798 44.6504 31.4199 45.4212 33.8638C46.07 35.9208 45.985 37.6837 45.7564 38.8968C46.0681 38.5851 46.3169 38.2245 46.4902 37.8317C46.7428 37.2588 46.8266 36.6363 46.734 36.0257L29.2615 46.568ZM29.2615 46.568C30.4804 49.3021 33.0498 51.3246 36.8482 52.6009L36.9156 52.4005L36.8488 52.6011C37.9202 52.9579 39.0516 53.1384 40.1909 53.1346M29.2615 46.568L40.1909 53.1346M40.1909 53.1346C41.6354 53.1409 43.064 52.8536 44.3741 52.2929C45.6843 51.732 46.8442 50.9112 47.7693 49.8883L47.7701 49.8874L47.8602 49.7867M40.1909 53.1346L46.734 36.0255C46.7128 35.8869 46.7439 35.747 46.8193 35.6295C46.8945 35.5124 47.0083 35.4257 47.139 35.3796C47.2696 35.3335 47.4125 35.3294 47.5456 35.3676C47.6788 35.4059 47.7977 35.4854 47.8804 35.5972L47.8836 35.6016L47.8836 35.6017C48.709 36.7808 49.3793 38.0458 49.8804 39.3703C50.547 41.1198 50.7113 42.9979 50.3569 44.8233C50.0026 46.6486 49.142 48.3577 47.8602 49.7867M47.8602 49.7867L47.8604 49.7864L47.7027 49.6454M47.8602 49.7867L47.7027 49.6454M47.7027 49.6454C48.9599 48.2439 49.8025 46.5694 50.1493 44.783C50.496 42.9966 50.3354 41.1584 49.6827 39.4454L47.7027 49.6454ZM30.3784 39.0143C30.919 39.7445 31.598 40.38 32.3833 40.8904L32.3832 40.8905L32.3867 40.8926C32.4758 40.9482 32.5776 40.981 32.6823 40.9894C32.787 40.9977 32.8928 40.9814 32.9898 40.9414C33.0869 40.9013 33.1733 40.8382 33.2394 40.7563C33.3057 40.6743 33.3492 40.5764 33.3638 40.4716L33.3639 40.4709C33.6615 38.2899 34.9026 36.4933 36.0934 35.2283C37.2649 33.9838 38.3715 33.2712 38.4313 33.2326C38.4322 33.2321 38.4329 33.2317 38.4333 33.2314L38.4335 33.2317L38.4434 33.2244C40.3782 31.8057 40.3932 29.7014 40.0425 28.1449C43.4128 31.1835 44.4699 34.0632 44.6674 36.2281C44.8752 38.5056 44.134 40.0208 44.0763 40.1344C44.0181 40.2477 43.9989 40.3762 44.0227 40.5017C44.0465 40.6271 44.1115 40.7398 44.2051 40.8256C44.2985 40.9111 44.4161 40.9662 44.5411 40.986C44.6659 41.0058 44.7947 40.99 44.9107 40.9398L30.3784 39.0143ZM30.3784 39.0143C29.846 40.5983 29.2387 43.4384 30.431 46.1058L30.431 46.1059C31.4934 48.4841 33.7778 50.2968 37.2729 51.4715L37.3867 51.5097L37.3868 51.5103C38.2877 51.7967 39.2356 51.9414 40.1903 51.9378L40.1921 51.9378C41.4551 51.9436 42.7033 51.6926 43.8468 51.2036C44.9896 50.7148 45.9985 50.0007 46.8019 49.1137L46.885 49.0185L46.887 49.0163C48.0284 47.7447 48.7922 46.2271 49.1068 44.6099C49.4214 42.993 49.277 41.329 48.6868 39.7773C48.4386 39.1301 48.1487 38.4971 47.8187 37.8815C47.4913 38.8466 46.8501 39.5688 46.2616 40.0641C45.574 40.6429 44.9414 40.9264 44.911 40.9396L30.3784 39.0143Z" fill="white" stroke="white" strokeWidth="0.423077" />
                        <path d="M38.4831 40.5824C37.9383 41.6956 37.6768 42.9047 37.7135 44.1181L36.4007 43.0274C36.369 43.0707 35.3928 44.4435 35.1062 46.3433C34.8163 48.2646 35.2357 50.7118 37.9921 52.8418L37.9922 52.8418C38.0102 52.8557 38.0288 52.8685 38.048 52.8803L37.9773 52.9776L38.3922 52.978C38.5181 52.9781 38.6425 52.9428 38.7485 52.8749C38.8548 52.8069 38.9387 52.7085 38.9857 52.5907C39.0327 52.4726 39.0392 52.3432 39.0037 52.221C38.9683 52.0992 38.8938 51.9934 38.794 51.9163C37.0526 50.5703 36.4164 49.1182 36.2939 47.8253C36.1916 46.7456 36.4461 45.7602 36.7443 45.0202C36.8777 45.2549 37.046 45.4715 37.2446 45.6638C37.5638 45.9728 37.9534 46.211 38.384 46.3621L38.3838 46.3625L38.3973 46.3663C38.5001 46.3949 38.6088 46.3984 38.7133 46.3766C38.8178 46.3548 38.916 46.3081 38.9978 46.2395C39.0796 46.1707 39.1425 46.0818 39.178 45.9805C39.2136 45.879 39.2198 45.7702 39.1957 45.6654C38.4616 42.4597 39.7829 40.383 40.9145 39.2536C40.9497 39.9562 41.1944 40.6352 41.6202 41.2167L41.7882 41.4519L41.7882 41.452L41.7899 41.4542C42.3713 42.246 43.0012 43.0068 43.6767 43.7328C44.1066 44.2109 44.4506 44.7477 44.6966 45.3229C44.7048 45.3442 44.7143 45.3649 44.725 45.385L44.7252 45.3854C45.614 47.0522 45.322 48.523 44.7883 49.6019C44.2509 50.6882 43.4711 51.3684 43.4143 51.4169L43.4142 51.4169L43.4119 51.419C43.2907 51.5258 43.216 51.676 43.2109 51.8389C43.2058 52.0019 43.271 52.1565 43.3861 52.2702C43.5006 52.3833 43.6552 52.4476 43.8156 52.4544C43.976 52.4612 44.1356 52.4103 44.2599 52.3083L44.26 52.3085L44.2667 52.3024C44.2666 52.3025 44.2665 52.3026 44.27 52.2996L44.2802 52.2905C44.2887 52.2829 44.3006 52.2722 44.3154 52.2586C44.345 52.2313 44.3866 52.1922 44.4377 52.142C44.5399 52.0415 44.6805 51.896 44.8411 51.7099C45.1618 51.3383 45.5643 50.8021 45.8984 50.137C46.5676 48.8048 46.9644 46.9463 45.8715 44.8742C45.5743 44.1775 45.1582 43.5293 44.6393 42.954L44.6394 42.954L44.6371 42.9516C43.9934 42.2598 43.393 41.5352 42.839 40.7813L42.671 40.5461L42.671 40.5461L42.669 40.5434C42.3692 40.1373 42.2007 39.6644 42.1803 39.1782C42.1718 38.7626 42.2786 38.3507 42.4921 37.9812L42.4921 37.9812L42.4934 37.9789C42.5589 37.8622 42.5822 37.7273 42.5578 37.5952C42.5334 37.4635 42.4637 37.3458 42.3632 37.2583C42.2631 37.1711 42.1372 37.1179 42.0053 37.1038C41.8734 37.0897 41.7391 37.1149 41.622 37.1773L41.6218 37.177L41.6108 37.1838C40.2438 38.024 39.1593 39.2009 38.4831 40.5824Z" fill="#035D67" stroke="#035D67" strokeWidth="0.423077" />
                      </g>
                      <defs>
                        <clipPath id="clip0_22_1432">
                          <rect
                            width="29.5385"
                            height="27.0769"
                            fill="#035D67"
                            transform="translate(24.6152 25.8462)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  {service.toUpperCase()}
                </React.Fragment>
              )
            )}
          </h5>

          <table className="services-summary-wrapper">
            <tbody>
              
              {service === "electricity" ? (

                props.values.planType === "Power Shift Plan" ? (
                  PowerShiftRates()
                ) : props.values.planType === "Power Lunch Plan" ? (
                  PowerLunchRates()
                ) : (
                  ElectricityRates()
                )

              ) : // display LGP rates
              !isLPGPage && service === "lpg" ? (
                <React.Fragment>
                  <tr>
                    <td style={{ paddingLeft: "0" }}>
                      <b>Standard Rates</b>
                    </td>
                  </tr>
                  {Object.entries(props.values.LPGDataFromDB[0]).map(
                    ([key, value]) => (
                      <React.Fragment>
                        <tr key={key}>
                          <td align="left" style={{ paddingLeft: "0" }}>
                            {formatKey(key)}
                          </td>
                          {/* <td align="right">{key==='Cylinder Rental' ? formatDollarRates(value-(props.values.allEnergyDiscount/100))+' /Day' : formatDollarRates(value)+' /Cylinder'}</td> */}
                          <td align="right" className="text-align-right">
                            {key === "CylinderRental"
                              ? formatDollarRates(value) + " /Day"
                              : formatDollarRates(value) + " /Cylinder"}
                          </td>
                        </tr>
                      </React.Fragment>
                    )
                  )}
                  <tr id="allEnergyDiscount">
                    <td align="left" style={{ paddingLeft: "0" }}>
                      All Energy Discount
                    </td>
                    <td align="right" className="text-align-right">
                      -
                      {formatDollarRates(props.values.allEnergyDiscount / 100) +
                        " /Day"}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ paddingLeft: "0" }}>
                      <b>Urgent Cylinder Delivery</b>
                    </td>
                  </tr>
                  {Object.entries(props.values.LPGDataFromDB[1]).map(
                    ([key, value]) => (
                      <React.Fragment>
                        <tr key={key}>
                          <td align="left" style={{ paddingLeft: "0" }}>
                            {formatKey(key)}
                          </td>
                          <td align="right" className="text-align-right">
                            {value === 0
                              ? "N/A"
                              : key === "CylinderRental"
                              ? formatDollarRates(value) + "/Day"
                              : formatDollarRates(value)}
                          </td>
                        </tr>
                      </React.Fragment>
                    )
                  )}
                </React.Fragment>
              ) : (
                // display Gas rates
                !isGasPage &&
                service === "gas" && (
                  <React.Fragment>
                    {props.values.gasRatesResult.MyGasQuote.GasQuote.map(
                      function (item, i) {
                        return (
                          <React.Fragment>
                            {item.Rate > 0 && (
                              <tr>
                                <td style={{ paddingLeft: "0" }}>
                                  {item.ContentDesc}
                                </td>
                                {/* <td>{item.ContentDesc === 'Fixed Daily Charges' ? formatRates(item.Rate-discount)+' /Day':formatRates(item.Rate)+' /kWh'}</td> */}
                                <td align="right">
                                  {item.ContentDesc === "Fixed Daily Charges"
                                    ? formatRates(item.Rate + discount) + "/Day"
                                    : formatRates(item.Rate) + "/kWh"}
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        );
                      }
                    )}
                    <tr id="allEnergyDiscount">
                      <td
                        align="left"
                        style={{ paddingLeft: "0" }}
                        className="summary-highlight"
                      >
                        All Energy Discount
                      </td>
                      <td align="right" className="summary-highlight">
                        <strong>-{formatRates(discount) + " /Day"}</strong>
                      </td>
                    </tr>
                  </React.Fragment>
                )
              )}
            </tbody>
          </table>
        </div>
      ));
      // }
    } else {
      return null;
    }
  };

  return (
    <div
      className="col-12 d-none d-sm-none d-md-block d-lg-block"
      id="sideBarServiceSummary"
    >
      <div className="row">
        <div className="col-9" style={{ marginBottom: "2rem" }}>
          <h4 className="h4 primary">Services</h4>
        </div>
        <div className="col-3 text-right">
          {props.values.canEdit && (
            <span
              href="#"
              style={{ cursor: "pointer" }}
              id="editButton"
              onClick={(e) => handleEdit(4)}
            >
              Edit
            </span>
          )}
        </div>
        <div className="col-12">
          {displaySummary()}
          <table>
            <tr id="gst-gas-summary">
              <td align="left" className={props.noGst ? 'gst-green' : ''} style={{ paddingLeft: "0" }}>
                <strong>{props.noGst ? 'With GST' : 'With GST'}</strong>
              </td>
              <td align="right" className="text-align-right">
                <label className="service-checkbox">
                  <input
                    type="checkbox"
                    id="noGstCheckbox"
                    name="noGstCheckbox"
                    checked={props.noGst}
                    onChange={props.handleNoGstChange}
                  />
                  <span className="checkmark"></span>
                </label>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  );
}